/**
 * Profile Page
 *  Author: Teemo
 *  CreatedAt: 2021-03-17
 */
import React, { useMemo } from 'react'; //, { useMemo }

import { get } from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { PreviewStyleSwitch } from '@/src/constrains/SalesChannelPreviewPageComponents/PreviewContainer';
import { dispatch } from 'src/store';

import PreviewContainer, {
  PreviewWrapper,
} from '@/src/constrains/SalesChannelPreviewPageComponents/PreviewContainer';
import PageWrapper from 'src/constrains/SalesChannelPreviewPageComponents/PageWrapper/PageWrapper';
import RightConfigWrapper from 'src/constrains/SalesChannelPreviewPageComponents/RightConfigWrapper';
import BasicPageHOC from 'src/constrains/SalesChannelPreviewPageComponents/SalesChannelContentBasicPageHOC';
import RouteBlock from 'src/pages/SalesChannelContentEditor/SalesChannelEditorHomepage/RouteBlock';
import Module from './Module';
import Preview from './Preview';
import PolicyPage from './Preview/policyPage';
import TopConfigs from './TopConfigs';

//import { EnumQuery } from 'src/pages/SalesChannelContentEditor/common';
import { EnumCollapseId, ModuleType } from './common';

import { convertDataFromReduxToServer } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorProfilePage/tools';
import { DEFAULT_MULTI_LANGUAGE_PARAMS } from '@/src/types/server/params';
import TranslationTip from 'src/constrains/SalesChannelAITranslation/TranslationTip';

import {
  fetchContentProfilePage,
  getCollapseOpenStatus,
  getHasModified,
  getLoaded,
  getSalesChannel,
  getSalesChannelName,
  getState,
  getTranslationState,
  submitContentProfilePage,
  validation,
  translateContentProfilePage,
} from './slice';

import styles from './css.less';
import { LinkModuleType } from '@/src/types/common/linkType';
import { EPreviewSize, WebSiteSubType } from '@/src/types/common/SalesChannel';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

export interface IParams {
  contentUuid: string;
  saleChannelUuid: string;
}

const SalesChannelEditorProfilePage = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  const _d = useDispatch();

  const {
    onDiscard,
    onGoBack,
    submitData,
    hasModified,
    salesChannel,
    salesChannelName,
    loaded,
    isOnPrimaryLanguage,
    currentStyle,
    currentSize,
    isMini,
  } = props;

  const _params: IParams = useParams();

  const responsiveTabOrMobile =
    currentStyle === WebSiteSubType.ResponsivePage &&
    (currentSize === EPreviewSize.TABLET ||
      currentSize === EPreviewSize.MOBILE);
  const { backgroundStyle, policy, moduleContentOrder } = useSelector(
    getState(),
  );

  const { image, backgroundColor } = backgroundStyle;

  const _policyOpen = useSelector(getCollapseOpenStatus(EnumCollapseId.policy));

  const { contentUuid } = _params;

  const renderFeatureProducts = useMemo(() => {
    const featureProducts = moduleContentOrder.filter(
      (o) => o.moduleType === ModuleType.FeaturedProduct,
    );
    if (get(featureProducts[0], 'products.children')) {
      featureProducts[0].products.children = null;
    }

    return {
      isValid: featureProducts.length > 0 ? featureProducts[0].enabled : false,
      title: featureProducts.length > 0 ? featureProducts[0].title : '',
      dataSet: featureProducts.length > 0 ? featureProducts[0].products : '',
      moduleType:
        featureProducts.length > 0 ? featureProducts[0].moduleType : '',
      titleTextColor:
        featureProducts.length > 0 ? featureProducts[0].titleTextColor : '',
    };
  }, [moduleContentOrder]);
  const { translationEnabled, translationLoading, uuid } = useSelector(
    getTranslationState(),
  );

  const multiLanguageParams = DEFAULT_MULTI_LANGUAGE_PARAMS;
  const renderEdmData = useMemo(() => {
    const _edmData = moduleContentOrder.filter(
      (o) => o.moduleType === ModuleType.Edm,
    );
    return _edmData.length > 0 ? _edmData[0] : [];
  }, [moduleContentOrder]);

  const handleOnTranslate = (translationEnabled) => {
    _d(
      translateContentProfilePage({
        uuid,
        translationEnabled,
        multiLanguageParams,
      }),
    );
  };

  return (
    <React.Fragment>
      <RouteBlock getHasModified={getHasModified} />
      <PageWrapper
        headerConfig={{
          hasModified,
          submit: submitData,
          salesChannelContentData: salesChannel || {},
          salesChannelName,
          onDiscard,
          onGoBack,
          hasStyleSelect: !isMini && true,
          handleOnTranslate,
          translationEnabled,
          translationLoading,
        }}
        leftChild={
          <PreviewStyleSwitch
            style={currentStyle}
            styleChild={
              <div
                style={{
                  height: 10000,
                  backgroundColor: 'yellow',
                  // margin: '0 auto',
                }}>
                123
              </div>
            }
            normalChild={
              <PreviewWrapper>
                {translationEnabled && !isOnPrimaryLanguage && (
                  <div className={styles.translationTip}>
                    <TranslationTip />
                  </div>
                )}
                <PreviewContainer
                  wrapperClassName={
                    translationEnabled ? styles.wrapperMarginTop : ''
                  }>
                  {!_policyOpen ? (
                    <Preview
                      featureProducts={renderFeatureProducts}
                      image={(image || {}).url}
                      backgroundColor={backgroundColor}
                      edmData={renderEdmData}
                    />
                  ) : (
                    <PolicyPage policy={policy} />
                  )}
                </PreviewContainer>
              </PreviewWrapper>
            }
          />
        }
        rightChild={
          loaded ? (
            <RightConfigWrapper
              title={getI18n('general.sider.profilePage')}
              elements={[
                {
                  body: (
                    <TopConfigs
                      isPrimary={isOnPrimaryLanguage}
                      linkSet={{
                        scopeVariables: {
                          SalesChannelContent: contentUuid,
                        },
                        linkTypeFilter: [LinkModuleType.LegalPage],
                      }}
                      currentStyle={currentStyle}
                      currentSize={currentSize}
                      disabled={translationEnabled}
                    />
                  ),
                  key: 'TopSettingContent',
                },
                !responsiveTabOrMobile
                  ? {
                      key: 'moduleContent',
                      body: isOnPrimaryLanguage ? (
                        <Module />
                      ) : (
                        <React.Fragment />
                      ),
                    }
                  : {},
              ]}
            />
          ) : null
        }
      />
    </React.Fragment>
  );
};

export default BasicPageHOC(SalesChannelEditorProfilePage, {
  siteStyleInParams: true,
  previewSizeInParams: true,
  getState,
  convertDataFromReduxToServer,
  submit: submitContentProfilePage,
  getHasModified,
  getSalesChannel,
  getSalesChannelName,
  validation,
  getLoaded,
  queryData: (params, qParams) => {
    const { contentUuid } = params;
    dispatch(
      fetchContentProfilePage({
        uuid: contentUuid,
        params: qParams,
      }),
    );
  },
});
